
import type { Candidate } from "@/components/candidates/types";
import type { Recruiter, PerformanceData, RadarDataPoint } from "../types";

export const calculatePerformanceData = (
  candidates: Candidate[],
  recruiters: Recruiter[]
): PerformanceData[] => {
  return recruiters.map((recruiter, index) => {
    const candidateCount = Math.floor(candidates.length / recruiters.length) +
      (index === 0 ? candidates.length % recruiters.length : 0);

    const hiredCount = Math.floor(candidateCount * (0.15 + (Math.random() * 0.15)));
    const interviewRate = 40 + Math.floor(Math.random() * 30);
    const responseTime = 1 + Math.floor(Math.random() * 2);
    const clientSatisfaction = 70 + Math.floor(Math.random() * 25);

    return {
      name: recruiter.name,
      candidates: candidateCount,
      hired: hiredCount,
      interviews: Math.floor(candidateCount * (interviewRate / 100)),
      responseTime,
      satisfaction: clientSatisfaction
    };
  });
};

export const calculateRadarData = (
  performanceData: PerformanceData[],
  recruiters: Recruiter[],
  totalCandidates: number
): RadarDataPoint[] => {
  return recruiters.map(recruiter => {
    const perfData = performanceData.find(p => p.name === recruiter.name);
    const safeCandidates = perfData?.candidates || 1; // Avoid division by zero
    const safeTotalCandidates = totalCandidates || 1; // Avoid division by zero

    return {
      name: recruiter.name,
      "Response Time": Math.round((3 - (perfData?.responseTime || 0)) * 33.3), // Lower is better, so invert
      "Hire Rate": Math.round(((perfData?.hired || 0) / safeCandidates) * 100),
      "Interview Rate": Math.round(((perfData?.interviews || 0) / safeCandidates) * 100),
      "Client Satisfaction": perfData?.satisfaction || 0,
      "Candidate Volume": Math.min(100, ((perfData?.candidates || 0) / safeTotalCandidates) * 200)
    };
  });
};
